import { createMigration } from './utils';
import { fixedColorMaps } from './resources/fixedColorMaps';

export const migrationTo9_155 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            map.get('children', []).forEach((child, c) => {
                if (child.get('classType') !== 'LottieAsset') {
                    return;
                }
                const sourceUrl = child.get('sourceUrl');
                const fixedColorMap = fixedColorMaps[sourceUrl];
                if (!fixedColorMap) {
                    return;
                }
                child.get('colorMaps', []).forEach((colorMap, cm) => {
                    const sourceColor = colorMap.get('sourceColor');
                    const fixedSourceColor = fixedColorMap[sourceColor];
                    if (!fixedSourceColor) {
                        return;
                    }
                    map.setIn(['children', c, 'colorMaps', cm, 'sourceColor'], fixedSourceColor);
                });
            });
        });
    },
});
